export const environment = {
  production: true,
  apiUrl: '@@host_backend@@',
  wsUrl: '',
  employeeSyncWsUrl: '',
  // siehe environment.prod.ts - derselbe Traefik-Aufbau gilt auch für die Test-Umgebung.
  wsPath: '/api/socket.io',
  useMocks: false,
  enableDevActions: true,
  version: '@@version@@'
};